import { Button, Flex,Text } from '@chakra-ui/react'
import {
  ArtistDetail,
  ContentNotFound,
  DetailPageNavigationHeader,
  Layout,
  RelatedWorks,
} from '@common'
import { ChevronLeft, Share } from '@icon'
import { ISSRPageData } from '@interfaces'
import { ArtistService } from '@services'
import { Link } from '@ui'
import { createNavLink } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
import { RWebShare } from 'react-web-share'

const ArtistDetailScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { asPath, locale, basePath } = useRouter()
  const { t } = useTranslation()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }



  return (
    <Layout
      title={pageData.data.artist?.fullName || t('common:ssmPageTitle')}
      navigation={navigation}
      path={asPath}
    >
      <DetailPageNavigationHeader
        variant="extended"
        leftChildren={
          <Flex>
            <Button
              as={Link}
              variant="unstyled"
              display="inline-flex"
              leftIcon={<ChevronLeft />}
              color={'black.primary3'}
              href={`${createNavLink('artist', locale)}/a-z/a`}
              fontSize="sm"
              fontWeight="light"
            >
              {t('common:allArtists')}
            </Button>
          </Flex>
        }
        rightChildren={
          <Flex overflowX="auto" flexDirection="column" alignItems="flex-end">
            <RWebShare
              data={{
                text: pageData.data.artist?.fullName || '',
                url: basePath,
                title: `${pageData.data.artist?.fullName || ''} | SSM`,
              }}
              closeText={t('common:closeLabel')}
            >
              <Button
                order={{ base: 2, lg: 1 }}
                variant="unstyled"
                display="inline-flex"
                rightIcon={<Share />}
                color={'black.primary3'}
                fontSize="sm"
                fontWeight="light"
              >
                {t('common:detailPageNavigation.share')}
              </Button>
            </RWebShare>
          </Flex>
        }
        containerProps={{
          mt: 'padding.primary',
        }}
      />
      {pageData.data.artist?.biography?.trim() ? (
        <ArtistDetail
          fullName={pageData.data.artist?.fullName}
          lifeRange={pageData.data.artist?.lifeRange}
          biography={pageData.data.artist?.biography}
          imgUrl={pageData.data.artist?.imgUrl}
          caption={pageData.data.artist?.caption}
          school={pageData.data.artist?.school}
          nationality={pageData.data.artist?.nationality}
          personType={pageData.data.artist?.personType}
          reference={pageData.data.artist?.reference}
          additionalReadings={pageData.data.artist?.additionalReadings}
        />
      ) : (
        <Flex mt="6" mb="12" justify="center" py={10}  background="white.primary2">
          <Text fontSize="lg" color="black.primary" textAlign="center">
            Detaylı bilgiye yakında bu sayfa üzerinden ulaşabilirsiniz.
          </Text>
        </Flex>
      )}


      {pageData.data.relatedObjects &&
        pageData.data.relatedObjects.length > 0 && (
          <RelatedWorks
            title={t('common:object.relatedWorks.title')}
            collection={pageData.data.relatedObjects}
          />
        )}
    </Layout>
  )
}

export default ArtistDetailScreen

interface ISSR {
  locale: string
  params: {
    id: string
  }
}

export async function getStaticProps({ locale, params }: ISSR) {
  const articleId = params?.id || null

  if (!articleId) {
    return {
      notFound: true,
    }
  }

  const pageData = await ArtistService.getArtistPageData(locale, articleId)

  return {
    props: {
      pageData,
    },
  }
}

export async function getStaticPaths() {
  const paths = []

  const articles = await ArtistService.getPeople()

  articles.map((article) => {
    paths.push({ params: { id: article.sourceId.value } })
  })


  return { paths, fallback: 'blocking' }
}
